/**
 * Created by will on 6/30/14.
 */
var committeeMode = angular.module('committeeMode', ['classy', 'feedbackModel']);
committeeMode.classy.controller({
    name: 'CommitteeModeController',
    inject: ['$scope', 'page', 'FeedbackModelService', 'authServiceFactory', '$timeout', 'CommitteeModeModelService', '$http',
        'StandardModalCudFactory', '$location', '$modalInstance', 'CommitteeUserModelService', 'socketApp'],
    init: function () {
        this.$.newUser = {};
        this.$.$modalInstance = this.$modalInstance;
        this.$.CommitteeModeModelService = this.CommitteeModeModelService;
        this.$.CommitteeUserModelService = this.CommitteeUserModelService;
        this.$.authServiceFactory = this.authServiceFactory;
        this.$.users = this.$.CommitteeUserModelService.get();
        this.$.item = this.CommitteeModeModelService.get()[0]; 
        this.new = 0;   
        var timezone = jstz.determine();
        this.$.now = new Date();
        var t = this.$.item.startDate.split(/[- :]/);
        var u = this.$.item.startTime.split(/[- :]/);
        if (t[0] !== "0000")
            this.$.committeeDate =  new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
        this.$.committeeTime =  new Date();
        
        var floor = new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
        floor.setHours(Number(u[0])-2);
        floor.setMinutes(u[1]);
        var ceiling = new Date(t[0], t[1]-1, t[2], u[0], u[1], u[2]);
        ceiling.setHours(Number(u[0])+2);
        ceiling.setMinutes(u[1]);

        if (this.$.committeeTime > floor && this.$.committeeTime < ceiling && this.$.item.active==0) {
            this.page = 0;
        }

        this.$.page = this.page;

        this.dateCompare = this.$.now - this.$.committeeDate;
        if (isNaN(this.dateCompare) || this.dateCompare > 0)
            this.$.startNew = true;
        else
            this.$.startNew = false;

        this.$.item.timezone = timezone.name();

        //Date Picker Stuff
        this.$.dateOptions = { formatYear: 'yy', startingDay: 1, showWeeks: false };
        this.$.minDate = new Date('1900-01-01');
        this.$.maxDate = new Date();
        this.$.formats = ['dd-MMMM-yyyy', 'yyyy/MM/dd', 'dd.MM.yyyy', 'shortDate', 'mmdd'];
        this.$.format = this.$.formats[0];
        if (this.$.item.startTime > '11:59:59')
            this.$.timeofday = "PM";
        else
            this.$.timeofday = "AM";
    },
    open: function($event, index) {
        $event.preventDefault();
        $event.stopPropagation();
        this.$.opened = [];
        this.$.opened[index] = true;
    },
    add: function()
    {
        for (var i = 0; i < this.$.users.length; i++)
        {
            if (this.$.users[i].email == this.$.newUser.email)
            {
                this.$.newUser.email = "";
                return false;
            }
        }
        var newUser = {};
        newUser.email = this.$.newUser.email;
        this.$.users.push(newUser);
        this.$.newUser.email = "";
    },
    fillDates: function()
    {
        for (var i = 0; i < this.$.users.length; i++) {
            this.$.users[i].expireDate = this.$.committeeDate;
        }
    },
    submit: function(scope, instance)
    {
        var parent = this;
        instance.options.factor  = .5;
        this.fillDates();
        
        this.$http.put("/api/school/" + this.authServiceFactory.getAuth().schoolID + "/CommitteeMode", this.$.item);

        this.$http.post("/api/school/" + this.authServiceFactory.getAuth().schoolID + "/CommitteeUser", this.$.users).then( function(){
            
        });
    },
    delete: function(index)
    {
        var user = this.$.users[index];
        var parent = this;
        if (typeof user.recordID !== "undefined")
        {
            this.CommitteeUserModelService.purge(user.recordID, user).then(function(res)
            {
                parent.$.users.splice(index, 1);
            });
        }
        else
            this.$.users.splice(index, 1);
    },
    startNewCommittee: function()
    {
        this.new = 1;
        this.$.committeeDate =  new Date();
        this.$.page++;
    },
    startMeeting: function()
    {
        this.$.item.active=1;
        this.socketApp.connect();
        var parent = this;
        this.$http.put("/api/school/" + this.authServiceFactory.getAuth().schoolID + "/CommitteeMode", this.$.item).then(function(data, status, headers, config) {
            instance.options.callMe(data, status, headers, config, instance);
            parent.$modalInstance.dismiss('cancel');
        });
    },
    endMeeting: function()
    {
        var parent = this;
        swal({
            title: "Are you sure?",
            text: "Are you sure you want to end the Committee Mode meeting?",
            type: "warning",
            showCancelButton: true,
            confirmButtonColor: "#DD68BB",
            confirmButtonText: "Yes",
            closeOnConfirm: true
        },
        function() {
            var grand = parent;
            parent.$.item.active=0;
            this.socketApp.disconnect();
            parent.$.item.startDate = '0000-00-00';
            parent.$.item.startTime = '00:00:00';
            parent.$http.put("/api/school/" + parent.authServiceFactory.getAuth().schoolID + "/CommitteeMode", parent.$.item).then(function(data, status, headers, config) {
                instance.options.callMe(data, status, headers, config, instance);
                grand.$modalInstance.dismiss('cancel');
            });
        });
        
    },
    nextPage: function(num)
    {
        if (num==undefined)
            this.$.page++;
        else
            this.$.page = num;
    },
    prevPage: function()
    {
        this.$.page--;  
    },
    activeChange: function(index, field)
    {
        this.$.users[index][field] = Number(this.$.users[index][field]);
    },
    getCurrentPage: function()
    {
        return "fast/submodules/schoolside/committeeMode/page" + this.$.page + ".html";
    },
    close: function(callback)
    {

        if (typeof callback !== 'undefined')
            callback();
        parent.$modalInstance.dismiss('done');
    }


});



committeeMode.service('CommitteeModeModalService', function($modal){
    var result = {}
    result.initModal = function(page)
    {
        return $modal.open({
            templateUrl: "fast/submodules/schoolside/committeeMode/committeeMode.html?v=" + versionNo,
            controller: "CommitteeModeController",
            size: 'md',
            backdrop: 'static',
            keyboard: false,
            resolve: {
                committeeMode: function (CommitteeModeModelService, authServiceFactory)
                {
                    return CommitteeModeModelService.get(authServiceFactory.getAuth().schoolID)
                },
                committeeUser: function (CommitteeUserModelService, authServiceFactory)
                {
                    return CommitteeUserModelService.get(authServiceFactory.getAuth().schoolID)
                },
                page: function()
                {
                    return page
                }
            }
        });
    }
    return result;
});